import request from '@/utils/request'

// 发布举报
export function reportSave(data) {
  return request({
    url: '/py/report/save',
    method: 'post',
    data
  })
}

// 获取验证码
export function getVerifyCode(phone) {
  return request({
    url: '/api/report/verifyCode',
    method: 'get',
    params: {
      phone
    }
  })
}
